import {BookingSearchResultRecordModel} from "../booking-search-result-record.model";
import {makeObservable, observable, runInAction} from "mobx";
import {IBookingSearchResultPageViewModel} from "./booking-search.strategy.interface";
import {IServiceFactory} from "../../service-factory.interface";

export class BookingSearchPaginatorModel {
    constructor(services: IServiceFactory) {
        if(services.screenMediaQuery.mAndBelow) {
            this.pageSize = 50;
        }

        makeObservable<this, '_pages' | '_hasMorePages'>(this, {
            _pages: observable,
            _hasMorePages: observable.ref,
        });
    }
    readonly pageSize: number = 51; // on large screens we have 3 columns so we need an odd value that divides exactly with 3
    private _pages: BookingSearchResultPageModel[] = [];

    get pages(): BookingSearchResultPageModel[] {
        return this._pages;
    }

    clearResults(): void {
        runInAction(() => {
            this._pages = [];
            this._hasMorePages = false;
        });
    }

    addPage(page: BookingSearchResultPageModel) {
        runInAction(() => {
            this._hasMorePages = page.records.length === this.pageSize;
            if(page.records.length > 0) {
                this._pages.push(page);
            }

        })
    }

    private _hasMorePages: boolean = false;

    get hasMorePages(): boolean {
        return this._hasMorePages;
    }

    get lastRecordIndex(): number {
        return Math.max(0, this.pages.sum(p => p.records.length) - 1);
    }
}

export class BookingSearchResultPageModel implements IBookingSearchResultPageViewModel {
    constructor(public readonly records: BookingSearchResultRecordModel[]) {
    }

}
